import type { IconData } from '@stacksjs/iconify-core'

export const bookmarkMinusF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M3 .858h8a3 3 0 0 1 3 3v15a2 2 0 0 1-3.348 1.477l-2.978-2.717a1 1 0 0 0-1.348 0l-2.978 2.717A2 2 0 0 1 0 18.858v-15a3 3 0 0 1 3-3m1 8a1 1 0 1 0 0 2h6a1 1 0 0 0 0-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default bookmarkMinusF
